const roomsJSON = require('../mock-data/engage-rooms.json');
const roomConfigurationsJSON = require('../mock-data/engage-room-configurations.json');
const meetingReasonsJSON = require('../mock-data/engage-meeting-reasons.json');
const advisorsJSON = require('../mock-data/advisors.json');

class MockRoomService {
    getRoomByName(friendlyName) {
        const room = roomsJSON.find(r => r.friendlyName === friendlyName);
        room.roomConfigurations = roomConfigurationsJSON.filter(config => config.roomId === room.id);
        room.meetingReasons = meetingReasonsJSON.filter(reason => reason.roomId === room.id);
        room.advisorOptions = advisorsJSON;
        return room;
    }
}

export default new MockRoomService();



// WEBPACK FOOTER //
// ./src/mocks/mock-json-services/room.service.js